import React from 'react'

// Bouton de retour au dashboard depuis un écran terrain plein écran
// (décision 20 du planning inventaires staff). Deux formes :
// - "pill" : libellé « Dashboard », en-tête des inventaires terrain (canvas W1)
// - "round" : icône seule de 48 px, pour l'en-tête des interventions

const GridIcon = ({ size }) => (
	<svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<rect x="3" y="3" width="7" height="7" rx="1.5" />
		<rect x="14" y="3" width="7" height="7" rx="1.5" />
		<rect x="3" y="14" width="7" height="7" rx="1.5" />
		<rect x="14" y="14" width="7" height="7" rx="1.5" />
	</svg>
)

export default function DashboardButton({ onClick, variant = 'pill' })
{
	if (variant === 'round')
	{
		return (
			<button
				type="button"
				onClick={onClick}
				aria-label="Retour au dashboard"
				title="Dashboard"
				className="w-12 h-12 rounded-full bg-slate-50 border border-slate-200 hover:bg-slate-100 active:scale-95 text-slate-600 flex items-center justify-center shadow-sm transition-all shrink-0"
				style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
			>
				<GridIcon size={20} />
			</button>
		)
	}
	return (
		<button
			type="button"
			onClick={onClick}
			style={{
				backgroundImage: 'none',
				backgroundColor: 'transparent',
				display: 'inline-flex',
				alignItems: 'center',
				gap: 8,
				minHeight: 48,
				padding: '0 16px',
				borderRadius: 999,
				border: '2px solid #C9CFDB',
				fontSize: 16,
				fontWeight: 600,
				color: '#000095',
				fontFamily: 'inherit',
				cursor: 'pointer'
			}}
		>
			<GridIcon size={24} />
			Dashboard
		</button>
	)
}
